export default class GetOrgEnumResponse {
  Id: string = "";
  Text: string = "";
  Description: string = "";
}
